import React, { useCallback } from 'react';

import { ClassName, GADataType, I18nText } from '../../../../../types';
import { IconsEnum } from '../../../../../assets/icons/types';

import { ProductUUID } from '../../../productsTypes';

import { useShowToastOnErrorChange } from '../../../../../common/hooks/useShowToastOnErrorChange';

import { useDownloadNanoId } from '../../../../downloads/hooks/useDownloadNanoId';

import { useDownloadProduct } from '../../../hooks/useDownloadProduct';

import { PureTooltipIconButtonHelper } from '../../../../../helpers/buttons/PureTooltipIconButtonHelper';
import { TooltipPlacement } from '../../../../../helpers/tooltips/tooltipsConstants';

interface DownloadProductButtonProps {
  className?: ClassName;
  i18nText?: I18nText;
  icon?: IconsEnum;
  iconClassName?: ClassName;
  productUuid: ProductUUID;
  tooltipI18nText?: I18nText;
  tooltipPlacement?: TooltipPlacement;
  tooltipSingleton?: boolean;
}

function DownloadProductButton({
  className,
  dataGa,
  i18nText,
  icon,
  iconClassName,
  productUuid,
  tooltipI18nText,
  tooltipPlacement,
  tooltipSingleton
}: DownloadProductButtonProps & GADataType) {
  const {
    downloadProductLoading,
    downloadProductErrorMessage,
    downloadProduct
  } = useDownloadProduct();

  useShowToastOnErrorChange({ error: downloadProductErrorMessage });

  const { downloadNanoId } = useDownloadNanoId();

  const handleClick = useCallback(() => {
    downloadProduct({
      uuid: productUuid,
      deviceNanoId: downloadNanoId
    });
  }, [productUuid, downloadNanoId, downloadProduct]);

  return (
    <PureTooltipIconButtonHelper
      className={className}
      dataGa={dataGa}
      icon={icon}
      iconClassName={iconClassName}
      i18nText={i18nText}
      disabled={downloadProductLoading}
      onClick={handleClick}
      tooltipI18nText={tooltipI18nText}
      tooltipSingleton={tooltipSingleton}
      tooltipPlacement={tooltipPlacement}
    />
  );
}

export default DownloadProductButton;
